import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import BasestationConnectionBody from './BasestationConnectionBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC, VICE_PRESIDENT_FSE } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import BasestationConnectionProvider from './context/BasestationConnectionProvider';

const BasestationConnection = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <BasestationConnectionProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - Basestation Connection" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <div className="container">
                  <BasestationConnectionBody />
                </div>
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </BasestationConnectionProvider>
    </div>
  );
};

export default BasestationConnection;
